import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper1 = new Swiper(".section6 .mySwiper", {
    navigation: {
        nextEl: ".section6 .swiper-button-next",
        prevEl: ".section6 .swiper-button-prev",
    },
    spaceBetween: '3.58%',
    slidesPerView: 2,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '3.58%',
            slidesPerView: 2,
        },
        768: {  //当屏幕宽度小于等于1280
            spaceBetween: '1.875%',
            slidesPerView: 2,
        },
        320: {  //当屏幕宽度小于等于320
            spaceBetween: 0,
            slidesPerView: 1,
        }
    }, 
});